﻿type ValueOf<T> = T[keyof T];

export function getPropertyName<T, TP extends T[keyof T]=any>(func: (x: T) => TP): ValueOf<{ [K in keyof T]: T[K] extends TP ? K : never }>;
export function getPropertyName(f: (x: any) => any): keyof any {
    return f(new Proxy({}, {get: (target, prop) => prop}));
}
